import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from 'deployable-app';
import errorHandler from 'lib/ErrorHandler';

import './index.css';

errorHandler.initialize();

const rootElement = document.getElementById('root');

createRoot(rootElement!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
